import React, {useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import {IconBox, Type as T} from "@infobis/ui-styles-utils";
import cn from "classnames"

import {Service} from "@context/map/mutableStore";
import FieldService, { GeoZoneHashElement } from "@context/map/fields/fieldsStore";
import MonitoringBackLink from "@components/modules/card/backLink/MonitoringBackLink";
import Sticker from "@components/elements/sticker/Sticker";
import List from "@components/elements/list/List";
import ItemList from "@components/elements/itemList/ItemList";
import Container from "@components/elements/container/Container";
import FlexLine from "@components/elements/flexLine/FlexLine";

import {Constants} from "@baseTypes/constants"
import {Align, Color, Crop, Field} from "@baseTypes/baseType";


import st from "./detailsField.module.scss"
import { ApplicationContext } from "@pages/monitoring/map/MapPage";
import { useTypedSelector } from "@hooks/useTypedSelector";
import colors from "@infobis/ui-styles-utils/colors";


const DetailsField = (props: any) => {
  
  let serviceStatus: any = useContext(Service);
  
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let location = useLocation();
  let params = useParams();
  
  let {fieldId } = params
  let ctx = useContext(ApplicationContext)

  let [detailedFiled, setDetailedField] = useState({} as GeoZoneHashElement)

  useEffect(() => {
    if (fieldId && ctx?.pixiContext) {
      ctx?.pixiContext.updateState(state => ({...state,
        showOnMap: true,
        selectedGeoZones: fieldId!.split(":")
      }))
    }
  }, [fieldId, ctx])
  const { entities: GeoZonesData, ids } = useTypedSelector(data => data.geoZones)
  useEffect(() => {

    let {fields, hashFields, type, options, meta} = FieldService
    if (fieldId) {
      const geoZone = GeoZonesData[fieldId]
      console.log('Show geoZone details', geoZone)
      if (geoZone) {
        setDetailedField(geoZone)
      }
    }
  }, [fieldId, ids])
  
  const {
    name,
    area,
    dynamic,
    manualArea
  } = detailedFiled
  
  return (
    <Container
      blur={true}
      className={st.container}
      color={Color.White}
      style={{
        height: "100%",
        padding: "24px"
      }}
    >
      <MonitoringBackLink
        path={"/map/fields"}
        title={Constants.Geozones}
      />
      
      <Container
        className={st.content}
        style={{
          marginTop: "24px"
        }}
        radius={true}
      >
        <List>
          <ItemList>
            <Sticker
              blur={true}
              radius={true}
            >
              <List>
                <ItemList className={st.title}>
                  <FlexLine className={st.title__name}>
                    <IconBox icon={T.IconName.Analytics} color={colors.CONTROL_DEFAULT_ICON_ICON}
                             className={st.icon}/>
                    <div>{name}</div>
                  </FlexLine>
                  <FlexLine align={Align.SpaceBetween} className={st.title__area}>
                    <FlexLine>
                      {area?.toFixed(2)} Га
                    </FlexLine>
                    {manualArea ? <FlexLine>
                      (Указано в ручную)
                    </FlexLine> : null}
                  </FlexLine>
                </ItemList>
                {dynamic?.cropsInfo.cropData.map((crop: Crop) => {
                  const {
                    id,
                    reproduction,
                    color,
                    endDate,
                    varieties,
                    title
                  } = crop
                  return (
                    <ItemList>
                      <FlexLine className={st.colorTitle}>
                        <div className={cn(st.icon, st.square)} style={{background: `#${color}`}}/>
                        {title}
                      </FlexLine>
                      {varieties ? <FlexLine align={Align.SpaceBetween}>
                        <FlexLine>
                          Cорт
                        </FlexLine>
                        <FlexLine>
                          {varieties}
                        </FlexLine>
                      </FlexLine> : null}
                      {reproduction ? <FlexLine align={Align.SpaceBetween}>
                        <FlexLine>
                          Репродукция
                        </FlexLine>
                        <FlexLine>
                          {reproduction}
                        </FlexLine>
                      </FlexLine> : null}
                    </ItemList>
                  )
                })}
              </List>
            </Sticker>
          </ItemList>
        </List>
      </Container>
    </Container>
  )
}
export default DetailsField